








































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { doublePrevention, performanceServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
})
export default class DetailPage extends Vue {
  @Prop(String) rowProp!: any; // 传递给编辑页面-数据对象
  private basicForm: any = {
    projectList: [],
    envProjectList: [],
    sign: '',
  };
  private projectRadio: any = 'project';
  private finishStaffName: any = '';
  private finishStaffSignUrl: any = '';
  imgPath: any = publishObjectPath.imgPathWater;

  riskLevelClass(level: any) {
    return {
      level_normal: level == '低风险',
      level_general: level == '一般风险',
      level_more: level == '较大风险',
      level_major: level == '重大风险',
    };
  }
  pollutionLevelClass(level: any) {
    return {
      level_normal: level == 'Ⅳ级',
      level_general: level == 'Ⅲ级',
      level_more: level == 'Ⅱ级',
      level_major: level == 'Ⅰ级',
    };
  }

  created() {
    this.getDetailData();
  }
  private getDetailData() {
    doublePrevention.getHandyCheckDetail(this.rowProp).then((res: any) => {
      if (res.code === '200') {
        this.basicForm = res.data;
        if (res.data.sign) {
          this.getValidatorCode(res.data.sign);
        }
      }
    });
  }
  // 获取签名图片 根据签名id
  private getValidatorCode(data: any) {
    performanceServer.getValidatorCode(data).then((res: any) => {
      if (res.code === '200') {
        this.finishStaffSignUrl = res.data.signature;
        this.finishStaffName = res.data.name;
      }
    });
  }
  private imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }

  backRole() {
    this.$emit('on-response');
  }

  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.imgPath}${item.path}`);
    });
    return arr;
  }
}
